// extracted by mini-css-extract-plugin
export default {"timeLimitInfoContainer":"style_timeLimitInfoContainer__YPqfe","text":"style_text__5rdS-","upper":"style_upper__Dg7bc"};